module.exports = __webpack_public_path__ + "static/media/05_avatar_male.3edb9efc.png";